if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        // Ensure the hidden input (which holds the variant id) is enabled.
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.sectionId = this.dataset.sectionId;

        // Select the size option element. (Ensure this selector matches your markup.)
        this.variantSelectsSize = document.querySelector('.option-Size');

        if (this.variantSelectsSize) {
          // Initially disable the button and set the placeholder text.
          this.submitButton.setAttribute('disabled', true);
          this.submitButton.querySelector('span').textContent = 'CHOOSE OPTION(S)';

          // Hide sold-out badges.
          document.querySelectorAll(`#price-${this.sectionId} .price__badge-sold-out`).forEach(badge => {
            badge.classList.add('hidden');
          });

          // Listen for a change event on the size select.
          this.variantSelectsSize.addEventListener('change', (event) => {
            const selectedValue = event.target.value;
            if (selectedValue) {
              // Enable the submit button and update its text.
              this.submitButton.removeAttribute('disabled');
              this.submitButton.querySelector('span').textContent = 'ADD TO CART';

              // Retrieve the variant JSON from the corresponding variant-selects element.
              let variants = [];
              const variantSelectsEl = document.getElementById(`variant-selects-${this.sectionId}`);
              if (variantSelectsEl) {
                const variantDataScript = variantSelectsEl.querySelector('script[type="application/json"]');
                if (variantDataScript) {
                  try {
                    variants = JSON.parse(variantDataScript.textContent);
                  } catch (e) {
                    console.error('Error parsing variants JSON:', e);
                  }
                }
              }

              // Find the matching variant by comparing option1 (size) with the selected value.
              const matchingVariant = variants.find(variant => variant.option1 === selectedValue);
              if (matchingVariant) {
                this.form.querySelector('[name=id]').value = matchingVariant.id;
              } else {
                console.warn('No matching variant found for selected size:', selectedValue);
              }
            } else {
              this.submitButton.setAttribute('disabled', true);
              this.submitButton.querySelector('span').textContent = 'CHOOSE OPTION(S)';
            }
          });
        }

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
